import {NullableNumber, NullableString} from "../../../types/nullable-types";
import {IServiceFactory} from "../../service-factory.interface";
import {PassengerTypeCodesEnum} from "../passenger-type-codes.enum";
import {PassengerTypeBase} from "./passenger-type-base";

export abstract class AdultBase extends PassengerTypeBase {
    get description(): string {
        return this.services.language.translate('Adult');
    }
    get implicitTitleValue(): NullableString {
        return null;
    }
    getMinimumAge(): number {
        return 12;
    }

    get isAdult(): boolean {
        return true;
    }

    get isChild(): boolean {
        return false;
    }

    get isInfant(): boolean {
        return false;
    }
    protected _getMaximumAge(): NullableNumber {
        return null;
    }

    get isDog(): boolean {
        return false;
    }

    get canBeMadePrimaryContact(): boolean {
        return true;
    }

    get isDateOfBirthMandatory(): boolean {
        return false;
    }
}

export class Adult extends AdultBase {
    constructor(services: IServiceFactory) {
        super(services, PassengerTypeCodesEnum.Adult);
    }
}

export class AdultBlueBenefits extends AdultBase {
    constructor(services: IServiceFactory) {
        super(services, PassengerTypeCodesEnum.AdultClubMember);
    }

    get isBlueBenefits(): boolean {
        return true;
    }
}

export class AdultWithChild extends AdultBase {
    constructor(services: IServiceFactory) {
        super(services, PassengerTypeCodesEnum.AdultWithChild);
    }

    get benefitDedicatedFreeSeats(): boolean {
        return true;
    }
}



/**
 * Adult that is at the same time a companion for a child and for another adult with reduced mobility
 */
export class AdultWithChildAndCompanionForPRM extends AdultBase {
    constructor(services: IServiceFactory) {
        super(services, PassengerTypeCodesEnum.AdultWithChildAndCompanionForReducedMobility);
    }

    get benefitReducedMobilityDiscount(): boolean {
        return true;
    }

    get benefitDedicatedFreeSeats(): boolean {
        return true;
    }
}

export class AdultWithReducedMobility extends AdultBase {
    constructor(services: IServiceFactory) {
        super(services, PassengerTypeCodesEnum.AdultWithReducedMobility);
    }

    get benefitReducedMobilityDiscount(): boolean {
        return true;
    }
}

export class Student extends AdultBase {
    constructor(services: IServiceFactory) {
        super(services, PassengerTypeCodesEnum.Student);
    }
}

export class StudentWithChild extends AdultBase {
    constructor(services: IServiceFactory) {
        super(services, PassengerTypeCodesEnum.StudentWithChild);
    }

    get benefitDedicatedFreeSeats(): boolean {
        return true;
    }
}

export class AdultWithMedicalReason extends AdultBase {
    constructor(services: IServiceFactory) {
        super(services, PassengerTypeCodesEnum.AdultWithMedicalReason);
    }
}

export class AdultWithMedicalReasonAndChild extends AdultBase {
    constructor(services: IServiceFactory) {
        super(services, PassengerTypeCodesEnum.AdultWithMedicalReasonAndChild);
    }

    get benefitDedicatedFreeSeats(): boolean {
        return true;
    }
}

export class AdultRetired extends AdultBase {
    constructor(services: IServiceFactory) {
        super(services, PassengerTypeCodesEnum.AdultRetired);
    }
}

export class AdultRetiredWithChild extends AdultBase {
    constructor(services: IServiceFactory) {
        super(services, PassengerTypeCodesEnum.AdultRetiredWithChild);
    }

    get benefitDedicatedFreeSeats(): boolean {
        return true;
    }
}

